export default "__VITE_PUBLIC_ASSET__bc0727c8__"